
import * as defaultImport from "@splunk/react-ui/ScreenReaderContent";
export * from "@splunk/react-ui/ScreenReaderContent";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
